export default "__VITE_ASSET__83fe5fd6__"